import { client } from './';
const url = '/oper';
const urlRule = '/rule';
const urlIndispsAlarm = '/indispsalarm';
const urlUnits = '/allUnits';
const urlEDInstructions = '/instr'

// IDs
export function fetchInboxInstructions(loggedUser){
  return dispatch => {
    dispatch({
      type: 'FETCH_INSTRUCTIONS_FOOTER',
      payload: client.post(url, {loggedUser: loggedUser})
    })
  }
}

// Alarmes Indisponiilidades
export function fetchOpenAlarms(loggedUser){
  return dispatch => {
    dispatch({
      type: 'FETCH_INDISPS_ALARMS',
      payload: client.post(urlIndispsAlarm, {loggedUser: loggedUser, status: 'new'})
    })
  }
}

//Regras
export function fetchRule(type,code) {
    return dispatch => {
        dispatch({
            type: 'FETCH_RULE_' + type,
            payload: client.post(urlRule, {code: code}),
        })
    }
}

//Centrais
export function fetchUnits(loggedUser){
  return dispatch => {
    dispatch({
      type: 'FETCH_ALL_UNITS',
      payload: client.post(urlUnits, {loggedUser: loggedUser})
    })
  }
}

//DIs Economical Dispacth
export function fetchEcoDispatchInstructions(loggedUser){
    return dispatch => {
        dispatch({
            type: 'FETCH_ED_INSTRUCTIONS_FOOTER',
            payload: client.post(
                urlEDInstructions, 
                {
                    prod: 'TODOS',
                    loggedUser: loggedUser
                }
            )
        })
    }
}

// Real time actions
export function addInstructionsFulfilled(data) {
	return {
		type: "ADD_INSTRUCTIONS_FOOTER_FULFILLED",
		newInstructions: data
	}
};

export function validateInstructionFulfilled(data) {
	return {
		type: "VALIDATE_INSTRUCTION_FOOTER_FULFILLED",
		instructionId: data.instructionId,
		instructionIdGu: data.instructionIdGu,
		newItem: data.newItem
	}
};

export function seeInstructionFulfilled(data) {
	return {
		type: "SEE_INSTRUCTION_FOOTER_FULFILLED",
		instructionId: data.instructionId,
		instructionIdGu: data.instructionIdGu
	}
};

export function rejectInstructionFulfilled(data) {
	return {
		type: "REJECT_INSTRUCTION_FOOTER_FULFILLED",
		instructionId: data.instructionId,
		instructionIdGu: data.instructionIdGu
	}
};

export function cancelInstructionFulfilled(data) {
	return {
		type: "CANCEL_INSTRUCTION_FOOTER_FULFILLED",
        instructionId: data.instructionId
	}
};

export function banInstructionFulfilled(data) {
	return {
		type: "BAN_INSTRUCTION_FOOTER_FULFILLED",
		instructionId: data.instructionId,
		instructionIdGu: data.instructionIdGu,
		comments: data.comments
	}
};

export function editInstructionFulfilled(data) {
	return {
		type: "EDIT_INSTRUCTION_FOOTER_FULFILLED",
		instruction: data.instruction
	}
};

export function setUpAlarmInstructionFulfilled(data) {
	return {
		type: "SETUPALARM_INSTRUCTION_FOOTER_FULFILLED",
		instruction: data.instruction
	}
};

export function setUpCTCHActiveAlarmsFulfilled(value) {
    return {
        type: "SETUPCTCH_ACTIVE_ALARMS_FULFILLED",
        alarmValue: value
    }
};

export function instructionsAddReceived(data) {
    // We return a function instead of an action object
    return (dispatch) => {
        dispatch(addInstructionsFulfilled(data));
    };
};

export function instructionValidateReceived(data) {
    // We return a function instead of an action object
    return (dispatch) => {
        dispatch(validateInstructionFulfilled(data));
    };
};

export function instructionSeeReceived(data) {
    // We return a function instead of an action object
    return (dispatch) => {
        dispatch(seeInstructionFulfilled(data));
    };
};

export function instructionRejectReceived(data) {
    // We return a function instead of an action object
    return (dispatch) => {
        dispatch(rejectInstructionFulfilled(data));
    };
};

export function instructionCancelReceived(data) {
    // We return a function instead of an action object
    return (dispatch) => {
        dispatch(cancelInstructionFulfilled(data));
    };
};

export function instructionBanReceived(data) {
    // We return a function instead of an action object
    return (dispatch) => {
        dispatch(banInstructionFulfilled(data));
    };
};

export function instructionEditReceived(data) {
    // We return a function instead of an action object
    return (dispatch) => {
        dispatch(editInstructionFulfilled(data));
    };
};

export function setUpAlarmInstructionReceived(data) {
    // We return a function instead of an action object
    return (dispatch) => {
        dispatch(setUpAlarmInstructionFulfilled(data));
    };
};

export function setUpCTCHActiveAlarms(value) {
    // We return a function instead of an action object
    return (dispatch) => {
            dispatch(setUpCTCHActiveAlarmsFulfilled(value));
    };
};

export const refreshDIsSocket= (socket, instructions, loggedUser) => {
	return (dispatch) => {
		let postData = {
                instructions: instructions,
				loggedUser: loggedUser
		}
	  socket.emit('refreshDIs', postData)		
	}	
};


// WEBPACK FOOTER //
// ./src/actions/footer-actions.js